<template>
  <div class="sidebar">
    <el-menu
      class="el-menu-vertical-demo"
      background-color="#232A36"
      text-color="#DDDDDD"
    >
      <router-link :to="{ path: '/' }">
        <div class="left_logo">
            <img src="../../assets/img/Logo.png" alt="">
        </div>
      </router-link>

      <!-- 用户头像 -->
      <div class="u_box_body" @click="open_view_profile">
        <div @dragstart.prevent>
          <el-avatar class="u_img_box" :size="50" :src="user_data.avatar || default_img "></el-avatar>
        </div>
        <div>
          <div class="u_tit">{{user_data.username || "-"}}</div>
          <div class="u_tit2">{{$t('main.text1')}}</div>
        </div>
      </div>

      <router-link :to="{ path: '/' }">
        <el-menu-item index="1" :class="index_active==1?'link_active':'' ">
          <img v-if="index_active==1" class="left_icon" src="../../assets/img/left_icon1_js.png" alt="">
          <img v-else class="left_icon" src="../../assets/img/left_icon1.png" alt="">
          <span slot="title">{{$t('main.text12')}}</span>
        </el-menu-item>
      </router-link>

      <router-link :to="{ path: '/cards' }">
        <el-menu-item index="12" :class="index_active==12?'link_active':'' ">
          <img v-if="index_active==12" class="left_icon" src="../../assets/img/left_icon12_js.png" alt="">
          <img v-else class="left_icon" src="../../assets/img/left_icon12.png" alt="">
          <span slot="title">{{$t('main.text512')}}</span>
        </el-menu-item>
      </router-link>

      <!-- 第三个 切换 -->
      <!-- <div class="sidebar_tit">{{$t('main.text25')}}</div> -->
      <router-link :to="{ path: '/blockchain_d' }">
        <el-menu-item index="3" :class="index_active==3?'link_active':'' ">
          <img v-if="index_active==3" class="left_icon" src="../../assets/img/left_icon5_js.png" alt="">
          <img v-else class="left_icon" src="../../assets/img/left_icon5.png" alt="">
          <span slot="title">{{$t('main.text14')}}</span>
        </el-menu-item>
      </router-link>

      <!-- 第四个 切换 -->
      <router-link :to="{ path: '/blockchain_w' }">
        <el-menu-item index="4" :class="index_active==4?'link_active':'' ">
          <img v-if="index_active==4" class="left_icon" src="../../assets/img/left_icon6_js.png" alt="">
          <img v-else class="left_icon" src="../../assets/img/left_icon6.png" alt="">
          <span slot="title">{{$t('main.text15')}}</span>
        </el-menu-item>
      </router-link>

      <!-- <div class="sidebar_tit">{{$t('main.text26')}}</div>
      <router-link :to="{ path: '/fiat_deposit' }">
        <el-menu-item index="5" :class="index_active==5?'link_active':'' ">
          <img v-if="index_active==5" class="left_icon" src="../../assets/img/left_icon5_js.png" alt="">
          <img v-else class="left_icon" src="../../assets/img/left_icon5.png" alt="">
          <span slot="title">{{$t('main.text16')}}</span>
        </el-menu-item>
      </router-link>

      <router-link :to="{ path: '/fiat_withdrawal' }">
        <el-menu-item index="6" :class="index_active==6?'link_active':'' ">
          <img v-if="index_active==6" class="left_icon" src="../../assets/img/left_icon6_js.png" alt="">
          <img v-else class="left_icon" src="../../assets/img/left_icon6.png" alt="">
          <span slot="title">{{$t('main.text17')}}</span>
        </el-menu-item>
      </router-link> -->

      <!-- <div class="sidebar_tit">{{$t('main.text27')}}</div> -->

      <!-- <router-link :to="{ path: '/otc' }">
        <el-menu-item index="7" :class="index_active==7?'link_active':'' ">
          <img v-if="index_active==7" class="left_icon" src="../../assets/img/left_icon7_js.png" alt="">
          <img v-else class="left_icon" src="../../assets/img/left_icon7.png" alt="">
          <span slot="title">{{$t('main.text18')}}</span>
        </el-menu-item>
      </router-link> -->

      <!-- <router-link :to="{ path: '/fx' }">
        <el-menu-item index="8" :class="index_active==8?'link_active':'' ">
          <img v-if="index_active==8" class="left_icon" src="../../assets/img/left_icon8_js.png" alt="">
          <img v-else class="left_icon" src="../../assets/img/left_icon8.png" alt="">
          <span slot="title">{{$t('main.text19')}}</span>
        </el-menu-item>
      </router-link> -->

      <!-- <router-link :to="{ path: '/private_b_p' }">
        <el-menu-item index="9" :class="index_active==9?'link_active':'' ">
          <img v-if="index_active==9" class="left_icon" src="../../assets/img/left_icon9_js.png" alt="">
          <img v-else class="left_icon" src="../../assets/img/left_icon9.png" alt="">
          <span slot="title">{{$t('main.text267')}}</span>
        </el-menu-item>
      </router-link> -->

      <!-- <router-link :to="{ path: '/structured_p' }">
        <el-menu-item index="10" :class="index_active==10?'link_active':'' ">
          <img v-if="index_active==10" class="left_icon" src="../../assets/img/left_icon10_js.png" alt="">
          <img v-else class="left_icon" src="../../assets/img/left_icon10.png" alt="">
          <span slot="title">{{$t('main.text268')}}</span>
        </el-menu-item>
      </router-link> -->

      <!-- <router-link :to="{ path: '/investment_b' }">
        <el-menu-item index="11" :class="index_active==11?'link_active':'' ">
          <img v-if="index_active==11" class="left_icon" src="../../assets/img/left_icon11_js.png" alt="">
          <img v-else class="left_icon" src="../../assets/img/left_icon11.png" alt="">
          <span slot="title">{{$t('main.text269')}}</span>
        </el-menu-item>
      </router-link> -->

      <router-link :to="{ path: '/my_transaction' }">
        <el-menu-item index="2" :class="index_active==2?'link_active':'' ">
          <img v-if="index_active==2" class="left_icon" src="../../assets/img/left_icon2_js.png" alt="">
          <img v-else class="left_icon" src="../../assets/img/left_icon2.png" alt="">
          <span slot="title">{{$t('main.text746')}}</span>
        </el-menu-item>
      </router-link>

      <div class="left_agreement" @click="open_agreement">{{ $t('beth_text.Cardholder_Agreement') }}</div>
    </el-menu>
  </div>
</template>

<script>
import {getUserInfo} from "@/api/api";

export default {
  data() {
    return {
      index_active:1,
      visible:false,
      visible2:false,
      visible3:false,
      kyc_status:0,
      user_data:'',
      default_img:require("../../assets/img/default_img.png"),
    };
  },
  methods: {
    set_active(){
      if(this.$route.path=='/'){
        this.index_active = 1;
      }else if(this.$route.path=='/my_transaction'){
        this.index_active = 2;
      }else if(this.$route.path.indexOf("blockchain_d")!=-1){
        this.index_active = 3;
      }else if(this.$route.path.indexOf("blockchain_w")!=-1){
        this.index_active = 4;
      }else if(this.$route.path.indexOf("fiat_deposit")!=-1){
        this.index_active = 5;
      }else if(this.$route.path.indexOf("fiat_withdrawal")!=-1){
        this.index_active = 6;
      }else if(this.$route.path.indexOf("otc")!=-1){
        this.index_active = 7;
      }else if(this.$route.path.indexOf("fx")!=-1){
        this.index_active = 8;
      }else if(this.$route.path.indexOf("private_b_p")!=-1){
        this.index_active = 9;
      }else if(this.$route.path.indexOf("structured_p")!=-1){
        this.index_active = 10;
      }else if(this.$route.path.indexOf("investment_b")!=-1){
        this.index_active = 11;
      }else if(this.$route.path.indexOf("cards")!=-1){
        this.index_active = 12;
      }

    },
    get_user_info() {
      getUserInfo().then((res) => {
        if (res.data.code == 200) {
          this.user_data = res.data.data;
          // console.log(this.user_data);          
        }
      });
    },
    open_view_profile(){
      if (this.$router.currentRoute.path!='/user_info') {
        this.$router.push('/user_info');
      }
    },
    open_agreement(){
      this.bus.$emit('open_agreement',true);
    }
  },
  mounted() {
    this.set_active();
    this.get_user_info();
  },
  watch:{
    $route(){
      this.set_active();
    }
  }
};
</script>

<style scoped>
.sidebar{
  width: 320px;
}
.left_logo{
  width: 135px;
}
.left_logo img{
  width: 100%;
  margin: 20px 0 28px 40px;
  display: inherit;
}
.el-menu{
  height: 100vh;
  overflow: hidden;
  border-right: none;
}
.sidebar_tit{
  font-style: normal;
  font-weight: bold;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: 0.06em;
  color: #FFFFFF;
  opacity: 0.4;
  padding-left: 25px;
  box-sizing: border-box;
  width: 86%;
  margin: auto;
  margin-top: 35px;
  margin-bottom: 5px;
}
.sidebar .link_active{
  color: #191E29 !important;
  background: #00C18E !important;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  border-radius: 8px;
}
.el-menu-item:focus, .el-menu-item:hover{
  border-radius: 8px;
}
.el-menu-item{
  width: 84%;
  margin: auto;
  height: 45px;
  line-height: 45px;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
}
.left_icon{
  width: 20px;
  margin-right: 10px;
  vertical-align: middle;
}
</style>

<style>
.sidebar_pop_box{
  /* background: #041E35 !important;#314B69 */
  background: rgb(30 75 114) !important;
  border-radius: 16px !important;
  border: none !important;
  color: #fff;
  box-sizing: border-box;
  padding: 28px;
  word-break: break-word;
  word-wrap: break-word;
  text-align: left;
  margin-left: 42px;
}
/* .sidebar_pop_box::after{ */
.sidebar_pop_box::before{
  content:"";
  background: rgba(0, 0, 0,0.5);
  width: 100%;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  z-index: -1;
}
.sidebar_pop_box .popper__arrow{
  display: none;
}
.sidebar_pop_box .pop_body{
  display: flex;
}
.sidebar_pop_box .pop_item1{
  width: 60px;
  margin-right: 20px;
}
.sidebar_pop_box .pop_item2{
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  margin-bottom: 4px;
}
.sidebar_pop_box .pop_item3{
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 22px;
  color: rgba(255, 255, 255, 0.8);
  /* margin-bottom: 20px; */
}
.sidebar_pop_box .pop_item3:nth-child(4){
  margin-bottom: 20px;
}

.sidebar_pop_box .pop_item4,
.sidebar_pop_box .pop_item4:hover,
.sidebar_pop_box .pop_item4:focus,
.sidebar_pop_box .pop_item4:active{
  min-width: 120px;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  color: #04182A;
  background: linear-gradient(90deg, #F1C788 0.42%, #E3A84E 100.42%);
  box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
  border-radius: 4px;
  border: none;
}
/* ------- */
.u_box_body{
  display: flex;
  background: #333A47;
  border-radius: 8px;
  box-sizing: border-box;
  padding: 12px;
  cursor: pointer;
  width: 84%;
  margin: 0 auto 28px;
  align-items: center;
}
.u_img_box{
  margin-right: 12px;
}
.u_tit{
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  color: #FFFFFF;
}
.u_tit2{
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: #DDDDDD;
  margin-top: 4px;
}
.left_agreement{
  position: absolute;
  bottom: 20px;
  cursor: pointer;
  width: 100%;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: #DDDDDD;
  margin-top: 4px;
  text-decoration: underline;
  box-sizing: border-box;
  padding-left: 15%;
}

</style>
